/**
 * Maps preferred J-code rows to MultiSelect options for tried/failed drugs.
 * @module buildPreferredDrugOptions
 */

import {
  PreferredDrugSelectOption,
  PreferredJcodeEntry,
} from "../statusUpdateModal.types";

/**
 * Builds MultiSelect options from preferred J-code rows.
 *
 * Label is `jCode - drugName` (or J-code alone); value is the J-code.
 * Empty or duplicate J-codes are skipped. Always appends a ``None`` option
 * (`value: "none"`) so the user can record that no preferred drug was tried.
 *
 * @input entries - Preferred J-code / drug-name rows
 * @return Options suitable for MultiSelectInput, including the None option
 */
export const buildPreferredDrugOptions = (
  entries: PreferredJcodeEntry[],
): PreferredDrugSelectOption[] => {
  const defaultOption = {
    label: "None",
    value: "none",
  };
  const seen = new Set<string>();
  const options: PreferredDrugSelectOption[] = [];

  for (const entry of entries) {
    const jCode = entry.jCode.trim();
    if (!jCode || seen.has(jCode)) {
      continue;
    }
    seen.add(jCode);
    const drugName = entry.drugName.trim();
    options.push({
      label: drugName ? `${jCode} - ${drugName}` : jCode,
      value: jCode,
    });
  }

  return [...options, defaultOption];
};
